"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleType = void 0;
var VehicleType;
(function (VehicleType) {
    VehicleType["MOTORCYCLE"] = "M";
    VehicleType["ATV"] = "A";
    VehicleType["PERSONAL_WATERCRAFT"] = "W";
    VehicleType["SNOWMOBILE"] = "S";
    VehicleType["RV"] = "R";
    VehicleType["BOAT"] = "B";
    VehicleType["OTHER"] = "O";
})(VehicleType = exports.VehicleType || (exports.VehicleType = {}));
